module.exports = __webpack_public_path__ + "img/moeda.98bbd5c0.svg";